import {EventEmitter} from 'events';

export const authenticationEmitter =  new EventEmitter();